export default __webpack_public_path__ + "static/trajectory-image-1cae0ab3167e0a839d4cc800e94ecc48.png";